import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import classNames from 'classnames'
import IcomoonReact from 'icomoon-react'
import { useToastAlert } from 'src/stores/ToastContext'
import rebrandIconSet from 'src/assets/icons/rebrandIconList.json'
import variables from 'src/assets/styles/variables.module.scss'
import generalStyles from 'src/assets/styles/generalStyles.module.scss'
import fontStyles from 'src/assets/styles/fontStyles.module.scss'
import fabStyles from './fabStyles.module.scss'

const FabContent = ({ fab }) => {
  const navigate = useNavigate()
  const { setAlert } = useToastAlert()
  const { eventId } = useParams()

  const onPressFab = (action) => {
    if (action?.key) {
      let url = `${action?.data}`
      if (
        action?.key === 'session_registration' ||
        action?.key === 'session_evaluation'
      ) {
        navigate(`/programs/${eventId}/agenda`)
      } else {
        if (action?.key === 'peer_to_peer') {
          const callbackUrl = window.location
          url += `/profile/wizard?wizard_from=web&callback=${callbackUrl}`
        }
        window.open(url, '_blank')
      }
    } else {
      setAlert({
        message: 'Unable to open floating action button item. Please try again later.',
        status: 0,
        title: 'Error',
        forceLogout: false
      })
    }
  }

  return (
    <div className={classNames(generalStyles.mt20, generalStyles.flexColumn)}>
            {fab.map((f, index) => {
        return (
          <div
            key={f.key}
            role="button"
            tabIndex={0}
            onClick={() => onPressFab(f)}
            onKeyDown={e => {
              if (e.key === 'Enter' || e.key === ' ') {
                onPressFab(f)
              }
            }}
            className={classNames(
              fabStyles.fabDivButton, // Optionally add a custom style for div-as-button
              index !== 0 && generalStyles.pt10,
              generalStyles.pb10,
              generalStyles.leftAlignedText,
              generalStyles.fullFlex
            )}
            style={{ cursor: 'pointer', outline: 'none' }}
          >
            <div
              className={classNames(
                generalStyles.flexRow,
                generalStyles.alignVertical,
                generalStyles.flexApart, 
                fabStyles.fabContentContainer
              )}
            >
              <div
                className={classNames(
                  generalStyles.flexRow,
                  generalStyles.alignVertical
                )}
              >
                <div className={fabStyles.iconContainer}>
                  <IcomoonReact
                    iconSet={rebrandIconSet}
                    color={variables.c01lightBase006ac7}
                    size={16}
                    icon={f.icon}
                  />
                </div>
                <span
                  className={classNames(
                    fontStyles.h6lsgartnersans18pt,
                    fontStyles.hoverable,
                    generalStyles.mr5
                  )}
                  style={{ width: '223px'}}
                >
                  {f.text}
                </span>
                <div className={fabStyles.clickContainer}>
                  <IcomoonReact
                    iconSet={rebrandIconSet}
                    size={16}
                    color={variables.c01lightBase006ac7}
                    icon={'Controls-Back'}
                  />
                </div>
              </div>
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default FabContent
